<template>
  <vx-card v-if="activeVenue" no-shadow>
    <h2 class="mb-6">Contact</h2>

    <div class="vx-row mb-6" v-for="(role, idx) in contactRoles" :key="idx">
      <div class="vx-col sm:w-1/5 w-full">
        <span>{{ contactRolesMap[idx] }}</span>
      </div>
      <div class="vx-col sm:w-2/5 w-full">
        <p
          v-for="user in contactUsers.filter((e) => e.userRole === role)"
          :key="user.userId"
        >
          {{ user.firstName }} {{ user.lastName }} - {{ user.email }} -
          {{ user.phoneCountryCode }}{{ user.phone }}
        </p>
      </div>
    </div>
  </vx-card>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  components: {},

  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      activeVenue: "venues/activeVenue",
      contactUsers: "venues/contactUsers",
      contactRoles: "venues/contactRoles",
      contactRolesMap: "venues/contactRolesMap"
    }),
  },
  methods: {},
  async mounted() {
    this.$vs.loading();
    await this.$store.dispatch("venues/getContactUsers");
    console.log("RESULT", this.contactUsers);
    this.$vs.loading.close();
  },
};
</script>

<style lang="scss" scoped>
.con-chips--remove-all {
  display: none;
}
</style>